$(window).on("resize", function () {
  // START: Home Hero Banner
  var windowHeight = $(window).height();
  //   var getNavHeight = $('header').height();


  $('.slideshow-slide__image-wrapper').css('height', windowHeight);
  // END: Home Hero Banner

  var windowWidth = $(window).width();
  $('.dynamic-comparison__inner-container').css('width', windowWidth);
  $('.dynamic-comparison__columns--text__text').css('width', windowWidth - 800);
}).resize();

$(document).ready(function(){
  $('.dynamic-comparison__wrapper, .faq__item h3').click(function(){
    //     $('.dynamic-comparison__wrapper').removeClass('active');
    $(this).toggleClass('active');
  });

  $('.dynamic-comparison__wrapper').hover(function(){
    if(!$(this).hasClass('active')) {
      $('.dynamic-comparison__wrapper').removeClass('active');
    }
  });


  var cartItem = $('span.site-header-cart--count').attr('data-header-cart-count');
  var cartIcon = $('ul.navmenu.navmenu-depth-1.site-navigation__secondary-menu i.fa-shopping-cart');

  cartIcon.after('<span>'+ cartItem +'</span>');

  if (cartItem > 0) {	
    cartIcon.addClass('active');
  }


  $('.dynamic-comparison__wrapper').hover(function(){
    $('.dynamic-comparison__wrapper').removeClass('hovered');
    $(this).addClass('hovered');
  });

  $('.product-description h3').each(function(){ $(this).nextUntil('h3').wrapAll('<div class="product-description__description"></div>'); })
  $('.product-description h3').click(function(){
    $(this).toggleClass('description-unfurl');

    var targetAcordion = $(this).next();
    var getActualHeight = targetAcordion.prop('scrollHeight');

    if ($(this).hasClass('description-unfurl')) {
      targetAcordion.css('max-height', getActualHeight);
    } else {
      targetAcordion.css('max-height', 0);
    }
  });

  $('.product-description h3').each(function(){
    var getHeaderText = $(this).text();
    var headerTextFilter = getHeaderText.replace(/[^a-z0-9\s]/gi, '').replace(/[_\s]/g, '').toLowerCase();

    $(this).addClass(headerTextFilter);
  });

  $("#mute-unmute").click( function (){
    $(this).toggleClass('active');
    if( $("video").prop('muted') ) {
      $("video").prop('muted', false);
    } else {
      $("video").prop('muted', true);
    }
  });

});

jQuery(document).ready(function() {
  setTimeout(function() {

    $('.dpo_tooltip_icon').click(function(){
      $('body').toggleClass('tooltip-active');
      $(this).toggleClass('tooltip-parent-active');
    });


    $("#dynamic_option_id_1001 input").click(function() {
      if ($(this).is(':checked')) {
        var getParentClass = $(this).parent().attr('class');
        $('.cfc').addClass(getParentClass);
      } else {
        var getParentClass = $(this).parent().attr('class');
        $('.cfc').removeClass(getParentClass);
      }
    });

    var stageOneSlider = $("img[alt='RPM Stage 1 Tune Slide Image']");
    var stageTwoSlider = $("img[alt='RPM Stage 2 Tune Slide Image']");

    stageOneSlider.parent().parent().addClass('slider-stage-one-active');
    stageTwoSlider.parent().parent().addClass('slider-stage-two-active');

    $("#dynamic_option_id_1001 input").click(function() {
      if ($(this).is(':checked')) {
        var getParentClass = $(this).parent().attr('class');
        $('.cfc').addClass(getParentClass);

        stageOneSlider.parent().parent().addClass(getParentClass);
        stageTwoSlider.parent().parent().addClass(getParentClass);

        //           $('figure.product-gallery--media.product-gallery--image').css('opacity', '0');
      } else {
        var getParentClass = $(this).parent().attr('class');
        $('.cfc').removeClass(getParentClass);

        stageOneSlider.parent().parent().removeClass(getParentClass);
        stageTwoSlider.parent().parent().removeClass(getParentClass);

        $('figure.product-gallery--media.product-gallery--image').removeAttr("style");
      }
    });

    $('.gallery-navigation--scroller, button.product-gallery--media-thumbnail').click(function(){
      stageOneSlider.parent().parent().removeClass('vgray-stage-1-tick');
      stageTwoSlider.parent().parent().removeClass('vgray-stage-2-tick');
      $('figure.product-gallery--media.product-gallery--image').removeAttr("style");
    });

    var scrollContainer = $('.dpo-container__recommended-content');

    if (scrollContainer.prop('scrollHeight') < 300 ) {
      scrollContainer.addClass('content-overflow');
    }

    $('.dpo-container__recommended-content').click(function () {

      var div = $('.dpo-container__features-content');
      var pos = div.offset().top;

      $(this).animate({
        scrollTop: pos
      }, 1000); // will take two seconds to scroll to the element

      $(this).parent().addClass('dpo-container--active');

    });
  }, 3000);



  setTimeout(function() {
    $('.loader').addClass('active');
  }, 2000);

  //   setTimeout(function() {
  //     var finalPrice = $('.hulkapps-cart-item-line-price').text();

  //     $('.cart-title-total span.money, .cart-subtotal span.money').text(finalPrice);

  //   }, 2000);

  setTimeout(function() {
    //START: Overflow Indicator
    var scrollContainer = $('.overflow-indicator');
    var heightLimit = 255; //height limit set to become scrollable

    scrollContainer.each(function(){
      if ($(this).prop('scrollHeight') >= heightLimit ) { 
        $(this).addClass('content-overflow');
      }
    });


    $('.overflow-indicator').click(function () {

      var div = $(this).parent();
      var pos = div.offset().top;

      $(this).animate({
        scrollTop: pos
      }, 1000); // will take one second to scroll to the element

      $(this).parent().addClass('overflow-indicator--active');

    });

    $('.overflow-indicator').scroll(function () {
      $(this).parent().addClass('overflow-indicator--active');
    });
    //END: Overflow Indicator

  }, 3000);

  setTimeout(function() {
    $('.delay-loading-time').addClass('delay-loading-time--active');
  }, 3000);

  setTimeout(function() {
    if($('.vgray-liability').length > 0) {
      $('.product-form--atc-icon').addClass('product-form--liability');
    }
  }, 3100);

});

$( window ).on( "load", function() {
  //START: RPM MOTORSPORT LTD WAIVER OF LIABILITY
  setTimeout(function() { 
    $("div#smartwaiver_floater").detach().appendTo("#waiver-container");
    $('div#smartwaiver_floater').show();

    $('div#smartwaiver_floater').click(function() {
      setTimeout(function() { 
        $('div#smartwaiver_container').detach().appendTo("#waiver-container");
        $('div#smartwaiver_container_bg').detach().appendTo("#waiver-container");
      }, 1000);
    });
  }, 2000);


  $('#smartwaiver_floater.smartwaiver_floater_center.smartwaiver_floater_open').click(function(){ 
    $(this).siblings().remove(); 
  });
  //END: RPM MOTORSPORT LTD WAIVER OF LIABILITY
});